import React from "react";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import Style from "./AboutUs.module.css";
const AboutUs = () => {
  return (
    <div className={Style.componentHolder}>
      <BurgerMenuTitle title={"درباره ی بَرِست"} />
      <div className={Style.picsHolder}>
        <div className={Style.picHolder}>
          <img alt="درباره برست" src={"./Assets/Images/AboutUs/1.jpeg"} />
        </div>
        {/* <div className={Style.picHolder}>
          <img alt="" src={"./Assets/Images/AboutUs/2.jpeg"} />
        </div> */}
        {/* <div className={Style.picHolder}>
          <img alt="" src={"./Assets/Images/AboutUs/3.jpeg"} />
        </div> */}
      </div>
      <div className={Style.textHolder}>
        <p className={Style.text}>
          اين سامانه، خدمات پيك درون شهري شهرستان بهشهر در استان مازندران را به
          صورت برخط انجام ميدهد و براي رفاه حال مردم منطقه در مدت دو سال با تكيه
          بر فن آوري بومي منطقه طراحي و اجرا شده است. مردم منطقه مي توانند
          سفارشاتشان را در سامانه ثبت كنند و از خدمات سامانه كه در آن سرعت، دقت
          و كيفيت مورد توجه قرار گرفته بهره مند شوند. فاز اول راه اندازي سامانه
          خريد از فروشگاه و رستوران بوده كه اكنون راه اندازي شده و قايل استفاده
          است. تاريخ افتتاح سامانه اول آذر ماه مي باشد. در فاز دوم خدمات سفارش
          هوشمند و جابجايي كالا مد نظر قرار گرفته كه تا پايان آذر ماه سال ١٤٠١
          راه اندازي خواهد شد.
        </p>
      </div>
      <div className={Style.EnamdHolder}>
        <img referrerpolicy="origin" src="https://trustseal.enamad.ir/?id=304894&Code=RP7P6Fqs7YZs6U0WCRhLV0fVQsnV4KOA" alt="Enamad" onClick={()=> window.open("https://trustseal.enamad.ir/?id=304894&Code=RP7P6Fqs7YZs6U0WCRhLV0fVQsnV4KOA", "_blank")}/>
      </div>
    </div>
  );
};

export default AboutUs;
